<template>
  <div class="container page">
    <van-nav-bar :title="$t('VIP级别')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="u-flex u-row-center u-col-center u-font-30" style="height: 2.8125rem; background-color: rgb(255, 255, 255); color: rgb(217, 29, 55);">
      {{ $t("等级荣誉") }}
    </div>
    <div class="u-flex u-row-between u-col-center u-font-32" style="height: 3.125rem;">
      <div class="u-flex-1 u-flex u-col-center u-row-center">{{ $t("等级") }}</div>
      <div class="u-flex-1 u-flex u-col-center u-row-center">{{ $t("图标") }}</div>
      <div class="u-flex-1 u-flex u-col-center u-row-center">{{ $t("名称") }}</div>
    </div>
    <div class="vipList u-flex u-row-between u-col-center border-bottom u-font-28" v-for="(item,key) in list" :key="key">
      <div class="u-flex-1 u-flex u-col-center u-row-center">{{ item.name }}</div>
      <div class="u-flex-1 u-flex u-col-center u-row-center">
        <img style="width: 4.375rem; height: 1.25rem;" :src="item.image" />
      </div>
      <div class="u-flex-1 u-flex u-col-center u-row-center">{{ item.name1 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list:"",
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    getLevelList(){
      this.$http({
        method: 'get',
        url: 'get_level_list'
      }).then(res=>{

        this.list = res.data;
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getLevelList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.u-font-30 {
  font-size: .9375rem;
}
.u-row-center {
  justify-content: center;
}
.u-col-center {
  align-items: center;
}
.u-flex {
  display: flex
;
  flex-direction: row;
  align-items: center;
}
.u-flex-1 {
  flex: 1;
}
.u-row-center {
  justify-content: center;
}
.u-col-center {
  align-items: center;
}
.vipList {
  background-color: #fff;
  border-bottom: 1px solid #eee;
  height: 2.75rem;
}
</style>
